import React, { useEffect, useState, useRef } from 'react';
import { createWebComponentWrapper } from '../utils/webComponentWrapper.ts';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from "js-cookie";

const SystemCompatibilityComponent = createWebComponentWrapper('rpt-system-compatibility');

interface SystemCompatibilityProps { }

const SystemCompatibility: React.FC<SystemCompatibilityProps> = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [mediaPermissions, setMediaPermissions] = useState({
    camera: false,
    microphone: false,
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const project = searchParams.get('project');
  const location = searchParams.get('location');
  const proctoringType = searchParams.get('proctoring_type') ?? "lite";

  const isLocationOn = () => {
      sessionStorage.setItem("isLocationOn","1")
      if(location == 'off' || process.env.REACT_APP_LOCATION_TYPE == 'off') {
        sessionStorage.setItem("isLocationOn","0")
        return false;
      }
      return true;
  }

  const angularComponentRef = useRef<HTMLElement>(null);

  useEffect(() => {
    Cookies.set("test_engine_project", project, { expires: 7 });
  }, [project])

  useEffect(() => {
    requestMediaPermissions();

    let attempts = 0;
    const maxAttempts = 50;

    const checkElement = () => {
      attempts++;

      if (!customElements) {
        setError('Custom Elements are not supported in this browser');
        return;
      }

      console.log('customElements', customElements.get('rpt-system-compatibility'));

      if (customElements.get('rpt-system-compatibility')) {
        setIsLoaded(true);
      } else if (attempts >= maxAttempts) {
        setError(`Failed to load Angular component after ${maxAttempts} attempts.`);
      } else {
        setTimeout(checkElement, 100);
      }
    };

    setTimeout(checkElement, 500);
  }, []);


  const requestMediaPermissions = async () => {
    try {
      if (!navigator.mediaDevices) {
        return;
      }

      const cameraStream = await navigator.mediaDevices.getUserMedia({
        video: { width: { ideal: 1280 }, height: { ideal: 720 } },
      });
      setMediaPermissions((prev) => ({ ...prev, camera: true }));
      cameraStream.getTracks().forEach((track) => track.stop());
    } catch (err) {
      console.log(err);
    }

    try {
      const audioStream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
      });
      setMediaPermissions((prev) => ({ ...prev, microphone: true }));
      audioStream.getTracks().forEach((track) => track.stop());
    } catch (err) {
      console.log(err);
    }
  };

  const handleCustomEvent = (event: CustomEvent) => {
    if (event.type === "continueBtnClick" || event.detail?.type === "continueBtnClick") {
      const loginPath = `/${Cookies.get("test_engine_project")}/login`;
      window.location.href = loginPath;
      return;
    }
    if (event.detail?.type === 'navigation' && event.detail?.path) {
      navigate(event.detail.path, { replace: true });
    }
  };


  if (error) {
    return (
      <div className="error-container">
        <h3>Error Loading Angular Component</h3>
        <p>{error}</p>
        <p>Make sure your Angular web component is built and placed in the correct directory.</p>
        <p>
          Expected path: <code>/angular-components/angular-app/</code>
        </p>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className="loading-container">
        <h3>Loading Application...</h3>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="angular-component-fullscreen">
      {/* <AngularApp
        data-testid="rpt-system-compatibility"
        className="angular-web-component"
        style={{ width: '100%', height: '100vh' }}
        onCustomEvent={handleCustomEvent}
        onContinueBtnClick={() => {
          const loginPath = `/${Cookies.get("test_engine_project")}/login`;
          window.location.href = loginPath;
        }}
        aria-label="System Compatibility Test"
        role="application"
        data-camera-permission={mediaPermissions.camera}
        data-microphone-permission={mediaPermissions.microphone}
      /> */}

      <SystemCompatibilityComponent
        ref={angularComponentRef}
        data-testid="rpt-system-compatibility"
        proctoring-type={proctoringType === 'live' ? 'live' : 'lite'}
        location-type={ isLocationOn() ? 'on' : 'off'}
        className="angular-web-component"
        style={{ width: '100%', height: '100vh' }}
        aria-label="System Compatibility Test"
        role="application"
        data-camera-permission={mediaPermissions.camera}
        data-microphone-permission={mediaPermissions.microphone}
        data-has-camera={mediaPermissions.camera}
        data-has-microphone={mediaPermissions.microphone}
        data-webcam-permissions={mediaPermissions.camera}
        data-microphone-permissions={mediaPermissions.microphone}
        onContinueBtnClick={handleCustomEvent}
        
      />
      
      {/* Error boundary - show message if Angular component fails */}
      {/* {!angularComponentRef.current && (
        <div className="error-boundary" style={{ 
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '20px', 
          backgroundColor: '#fff3cd', 
          border: '1px solid #ffeaa7', 
          borderRadius: '4px',
          color: '#856404',
          zIndex: 1000
        }}>
          <h4>⚠️ Angular Component Loading</h4>
          <p>The Angular component is still initializing. This won't affect the rest of the page.</p>
        </div>
      )} */}
    </div>
  );
};

export default SystemCompatibility;